import React, { ReactElement, useState, useEffect } from "react";
import { Button, Card, Flex, Input, Select, Tag, Typography } from "antd";
import {
  ArrowRightOutlined,
  BulbOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { TypeAnimation } from "react-type-animation";
import { ReactTyped } from "react-typed";
import { Expert } from "../code/utils";
import { ChatMessageProps } from "./ChatMessage";
import PromptModal from "./PromptEditor";

const { Title } = Typography;
const { Text } = Typography;

export interface AutoSizeType {
  minRows?: number;
  maxRows?: number;
}

interface ChatBoxProps {
  experts?: Map<string, Expert>;
  onExpertChange?: (value: any, option: Expert | Expert[]) => void;
  expert?: Expert;
  autoSize: boolean | AutoSizeType | undefined;
  onMessage: Function;
  conversationStarted: boolean;
  errors: Array<string>;
  disabled?: boolean;
}

const ChatBox: React.FC<ChatBoxProps> = (props) => {
  const [focused, setFocused] = useState<boolean>(false);
  const [curText, setCurText] = useState<string>("");
  const [prompt, setPrompt] = useState<string>("");

  // function onExpertChange(key:string){
  //     setExpert(experts.get(key));
  // }

  const expertOpts = props.experts ? Array.from(props.experts.values()) : [];

  useEffect(() => {
    if (props.expert) {
      setPrompt(props.expert.prompt);
    }
  }, [props.expert]);

  function handleSubmit() {
    console.log(prompt);
    props.onMessage(curText, prompt);
    setCurText("");
  }

  // function setPrompt(newPrompt:string){
  //     if(props.expert){
  //         props.expert.prompt = newPrompt;
  //     }
  // }

  return (
    <Flex style={{ width: "100%" }} justify="center" align="center" vertical>
      <div style={{ width: "100%" }}>
        {props.errors.map((e) => {
          return (
            <Text key={e} type="danger">
              {"*" + e}
            </Text>
          );
        })}
      </div>
      <Flex 
        align="center" 
        style={{ 
          width: "100%",
          backgroundColor: "#FbF3F2",
          border: "1px solid rgba(3, 37, 57, 0.2)",
          borderRadius: "8px",
          padding: "8px 12px",
          gap: "8px"
        }}
      >
        <Input.TextArea
          onBlur={() => setFocused(!focused)}
          onFocus={() => setFocused(!focused)}
          onChange={(e) => {
            setCurText(e.target.value);
          }}
          onPressEnter={(e) => {
            if (!e.shiftKey && !props.disabled) {
              e.preventDefault();
              handleSubmit();
            }
          }}
          value={curText}
          disabled={props.disabled}
          placeholder={
            props.disabled 
              ? "Please sign in and activate your account to chat"
              : "Ask" +
                (props.expert ? " " + props.expert.friendlyName : "") +
                " a question..."
          }
          style={{ 
            flex: 1,
            border: "none",
            backgroundColor: "transparent",
            color: "#032539",
            resize: "none",
            boxShadow: "none"
          }}
          autoSize={{ minRows: 1, maxRows: 4 }}
        />
        <Button
          onClick={handleSubmit}
          shape="circle"
          type="primary"
          icon={<ArrowRightOutlined />}
          disabled={props.disabled}
          style={{
            backgroundColor: props.disabled ? "#ccc" : "#032539",
            borderColor: props.disabled ? "#ccc" : "#032539",
            color: "#FbF3F2",
            flexShrink: 0
          }}
        />
      </Flex>
    </Flex>
  );
};

// export default ChatMessage;
export { type ChatBoxProps, ChatBox };
